import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import "moment-timezone";
import 'react-slidedown/lib/slidedown.css'
import Tooltip from "@material-ui/core/Tooltip";

import general from "../general";
import {styles} from "assets/jss/fases-acontecimento.jsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class FasesAcontecimento extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {classes, fases} = this.props;

    let max_idx = 0;
    fases.forEach((fase, idx) => {
      let valor = fase.value || this.props.acontecimento[fase.field];
      if (!valor)
        return;
      if (new Date(valor) <= new Date())
        max_idx = idx + 1;
    });

    return <div className={classes.wrapper}>
      <div style={{minWidth: 150 * fases.length}}>
        {fases.map((fase, idx) => {
          let active = idx < max_idx;
          let item = <div className={[classes.itemWrapper, idx - 1 < max_idx && active && classes.itemWrapperActiveRight, active && classes.itemWrapperActiveLeft].filter(a => a).join(" ")}>
            <span className={[classes.itemCircle, active && classes.itemCircleActive].filter(a => a).join(" ")}><FontAwesomeIcon style={{width: 22, height: "auto"}} icon={fase.icon}/></span>
            <div>
              <p className={classes.itemText}>{fase.descripion[active ? 1 : 0]}</p>
              <p className={classes.itemDate}>{general.Renderers.dateRenderer(fase.value || this.props.acontecimento[fase.field], {hide_timezone: true, default: ""})}</p>
            </div>
          </div>;
          if (!this.props.acontecimento[fase.field])
            return item;
          return <Tooltip
            title={general.Renderers.dateRenderer(this.props.acontecimento[fase.field])}
            placement="top"
            classes={{tooltip: classes.tooltip}}
          >{item}</Tooltip>;
        })}
      </div>
    </div>;
  }
}

export default withStyles(styles)(FasesAcontecimento);
